import { RequireKey } from "@material-dev/insights-portal-ui-components/lib/types";
import { OriginProjectDto } from "app/ApiClient";
import { BaseState } from "..";

export type NormalizedROriginProject = RequireKey<OriginProjectDto, "name">;


export interface ROriginProjectState extends BaseState {
  rOriginProjects: NormalizedROriginProject[];
  isFetching?: boolean;
}

export const defaultROriginProjectsState: ROriginProjectState = {
  processing: false,
  finished: false,
  failed: false,
  succeed: false,
  error: "",
  rOriginProjects: [],
  isFetching: false,
};

